// Consent check pour les JS qui créent des iframes tiers dynamiquement.
// Lit le localStorage directement (pas de dépendance au store Interactivity).

const KEY = 'ndg_consent';

export function hasAnalyticsConsent() {
  if (!window.__ndgBlockEmbeds) return true;
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return false;
    return !!JSON.parse(raw).analytics;
  } catch (e) {
    return false;
  }
}
